import React from 'lib/react';
import PropTypes from 'prop-types';
import { EVGrid } from 'lib/components';
import Typography from 'commonComponents/typography';
import AnalyticsBarChart from 'commonComponents/analyticsBarChart';
import { ChartsReferenceLine } from '@mui/x-charts';
import { useTranslation } from 'lib/translation';
import HistoricUsageStyles from './HistoricUsageStyles';

function HistoricUsage({ historicUsage, totalAllowed }) {
  const { t } = useTranslation();
  const classes = HistoricUsageStyles();
  const getFormattedHistoricUsageData = () => historicUsage.map((item) => ({
    ...item,
    usedBelow: item.qty < totalAllowed ? item.qty : null,
    usedAbove: item.qty >= totalAllowed ? totalAllowed : null,
    available: Math.max(0, totalAllowed - item.qty),
    overage: Math.max(0, item.qty - totalAllowed),
  }));

  const formattedValue = (value) => (value ? `${value} Reports` : null);

  const historicUsageBarChartSeries = [
    {
      dataKey: 'usedBelow',
      color: '#007CAD',
      label: 'Used',
      valueFormatter: formattedValue,
      stack: 'usage',
    },
    {
      dataKey: 'usedAbove',
      color: '#117A37',
      label: 'Used',
      valueFormatter: formattedValue,
      stack: 'usage',
      hide: true,
    },
    {
      dataKey: 'overage',
      color: '#CC7000',
      label: 'Overage',
      valueFormatter: formattedValue,
      stack: 'usage',
    },
  ];

  return (
    <EVGrid className={classes.historicUsageContainer}>
      <Typography variant="h3-600" fontColor="charcoal-900">
        {t('subscription_dashboard__historic_usage')}
      </Typography>
      <EVGrid className={classes.barChartDiv}>
        <AnalyticsBarChart
          dataset={getFormattedHistoricUsageData()}
          series={historicUsageBarChartSeries}
          margin={{
            top: 0, right: 0, bottom: 24, left: 0,
          }}
          height={150}
          xAxis={[{
            scaleType: 'band',
            dataKey: 'month',
            categoryGapRatio: 0.2,
            disableTicks: true,
            valueFormatter: (month) => month,
          }]}
          bargapratio={0}
          leftAxis={null}
          grid={{ vertical: false }}
          sx={{
            '& .MuiChartsGrid-lineVertical:not(:first-of-type):not(:last-of-type)': {
              stroke: 'none',
            },
          }}
        >
          <ChartsReferenceLine
            y={totalAllowed}
            lineStyle={{
              stroke: '#6B7280',
              strokeDasharray: '5 5',
              strokeWidth: 1,
            }}
          />
        </AnalyticsBarChart>
      </EVGrid>
    </EVGrid>
  );
}

HistoricUsage.propTypes = {
  historicUsage: PropTypes.arrayOf(PropTypes.shape({
    month: PropTypes.string.isRequired,
    qty: PropTypes.number.isRequired,
  })).isRequired,
  totalAllowed: PropTypes.number.isRequired,
};

export default HistoricUsage;
